import MicroModal from 'micromodal';

const selectors = {
  zoomImage: '[data-image-zoom]',
  attrUnique: 'data-unique',
};

class GalleryZoom {
  constructor(container) {
    this.triggers = container.querySelectorAll(selectors.zoomImage);
    this.init();
  }

  init() {
    this.triggers.forEach((trigger) => {
      const unique = trigger.getAttribute(selectors.attrUnique);

      MicroModal.init({
        disableScroll: true,
        openTrigger: `data-popup-${unique}`,
        onShow: (modal) => {
          var images = modal.querySelectorAll('[data-src]', modal);
          images.forEach((image) => {
            if (image.getAttribute('src') === null) {
              const bigImage = image.getAttribute('data-src');
              image.setAttribute('src', bigImage);
            }
          });
        },
        onClose: (modal, el, event) => {
          event.preventDefault();
        },
      });
    });
  }
}

const galleryZoomSection = {
  onLoad() {
    new GalleryZoom(this.container);
  },
};

export default galleryZoomSection;
